import { render } from "./CloseBtn.vue?vue&type=template&id=70e4045a"
import script from "./CloseBtn.vue?vue&type=script&lang=js"
export * from "./CloseBtn.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/mooz360.co.il/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__